module.exports = "/_next/static/images/af1902660446ccd42977d6396d82d71d-celebrate.jpg";